export default "__VITE_ASSET__Bhr4AALc__"